<div class="account-apis">
  @if ((isLoading$ | async) === false) {
    @if (clientDetails) {
      <div class="account-apis-field">
        <div class="input-title">
          {{ 'userManagementPage.apisPage.clientIdTitle' | labelsProvider }}
        </div>
        <div class="input-description">
          {{ 'userManagementPage.apisPage.clientIdDescription' | labelsProvider }}
        </div>
        <app-input-with-operations class="input-content" [withCopyButton]="true" [value]="clientDetails.clientId">
        </app-input-with-operations>
      </div>
      <div class="account-apis-field">
        <div class="input-title">
          {{ 'userManagementPage.apisPage.clientSecretTitle' | labelsProvider }}
        </div>
        <div class="input-description">
          {{ 'userManagementPage.apisPage.clientSecretDescription' | labelsProvider }}
        </div>
        <div class="input-content-with-operation">
          <app-input-with-operations
            class="input-content"
            [withCopyButton]="true"
            [withViewButton]="true"
            [value]="clientDetails.clientSecret"
          >
          </app-input-with-operations>
          <app-button
            [buttonTextLabelPath]="'userManagementPage.apisPage.clientSecretRotation'"
            [buttonIconPath]="'assets/images/common/refresh.svg'"
            (buttonClicked)="rotateSecretClicked()"
          ></app-button>
        </div>
      </div>
    }

    @if (showNoData) {
      <app-no-data [tableNotFoundText]="'userManagementPage.apisPage.notFoundText' | labelsProvider"> </app-no-data>
    }
  } @else {
    <div class="account-apis-spinner">
      <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
    </div>
  }
</div>
